import { getWindow } from "@faire/web--source/common/globals/getWindow";

import { loadQualtricsCSATSurvey } from "./loadQualtricsCsatSurvey";

/**
 * Passes the externalReference ID of the user to Qualtrics to associate the website
 * visitor with a contact in XM Directory. Ensure this happens before loading qualtrics.
 * https://www.qualtrics.com/support/website-app-feedback/common-use-cases/xm-directory-segments-for-digital-intercept-targeting/#JavaScriptExpression
 * @param userToken
 */
export const retrieveExtRefId = (userToken: string | undefined) => {
  const globalWindow = getWindow() as any;

  if (typeof globalWindow.QSI === "undefined") {
    globalWindow.QSI = {};

    globalWindow.QSI.config = {
      externalReference: userToken,
    };
  }
};

/**
 * Runs retrieveExtRefId() and loadQualtricsCSATSurvey() in the correct sequence to
 * setup qualtrics with a link to the XM directory
 * https://www.qualtrics.com/support/iq-directory/getting-started-iq-directory/getting-started-with-iq-directory/
 * @param userToken
 * @param loadQualtricsCallback - callback to decide which Qualtrics survey to load, default is company-wide CSAT survey
 */
export const loadQualtricsWithLinkToXMDirectory = (
  userToken: string | undefined,
  loadQualtricsCallback: () => void = loadQualtricsCSATSurvey
) => {
  retrieveExtRefId(userToken);
  loadQualtricsCallback();
};

export enum QualtricsBrandEvent {
  publishProduct = "publishProduct",
  bulkUploadProducts = "bulkUploadProducts",
  revisitFaireForTeamsPage = "revisitFaireForTeamsPage",
  linesheetImport = "linesheetImport",
  productsPageWithShopifySync = "productsPageWithShopifySync",
  rejectUnlistedProducts = "rejectUnlistedProducts",
}

export enum QualtricsRetailerEvent {
  executeSearch = "executeSearch",
  clickOnCatnav = "clickOnCatnav",
  clickOnHomepageCarousel = "clickOnHomepageCarousel",
  closeRequestUnlistedProductsModal = "closeRequestUnlistedProductsModal",
}

/**
 * Triggers a Qualtrics event that are used for intercepts
 * https://www.qualtrics.com/support/website-app-feedback/intercepts-tab/edit-intercept-section/action-set-options/adding-event-tracking-triggering
 * @param eventName
 */
export const triggerQualtricsEvent = (
  eventName: QualtricsBrandEvent | QualtricsRetailerEvent
) => {
  const globalWindow = getWindow() as any;
  if (typeof globalWindow._qsie === "undefined") {
    globalWindow._qsie = [];
  }
  globalWindow._qsie.push(eventName);
};
